import { render, staticRenderFns } from "./CuentaCobrarPagar.vue?vue&type=template&id=5517c8c6&"
import script from "./CuentaCobrarPagar.vue?vue&type=script&lang=js&"
export * from "./CuentaCobrarPagar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports